"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HAVE_CHILDREN_QUALIFICATION_NAME = exports.CRITERIA_QUOTA_TYPE_RANGESET = exports.CRITERIA_QUOTA_TYPE_NORMAL = exports.MONTHS_CHILD_AGE_UNIT_CODE = exports.YEARS_CHILD_AGE_UNIT_CODE = exports.CHILD_AGE_QUALIFICATION_ID = exports.GIRL_CHILD_GENDER_CONDITION_CODE = exports.BOY_CHILD_GENDER_CONDITION_CODE = exports.CHILD_GENDER_QUALIFICATION_ID = exports.NO_HAVE_CHILDREN_CONDITION_CODE = exports.YES_HAVE_CHILDREN_CONDITION_CODE = exports.HAVE_CHILDREN_QUALIFICATION_ID = void 0;
exports.HAVE_CHILDREN_QUALIFICATION_ID = 218;
exports.YES_HAVE_CHILDREN_CONDITION_CODE = 112;
exports.NO_HAVE_CHILDREN_CONDITION_CODE = 111;
exports.CHILD_GENDER_QUALIFICATION_ID = 220;
exports.BOY_CHILD_GENDER_CONDITION_CODE = 111;
exports.GIRL_CHILD_GENDER_CONDITION_CODE = 112;
exports.CHILD_AGE_QUALIFICATION_ID = 230;
exports.YEARS_CHILD_AGE_UNIT_CODE = 311;
exports.MONTHS_CHILD_AGE_UNIT_CODE = 312;
exports.CRITERIA_QUOTA_TYPE_NORMAL = 'normal';
exports.CRITERIA_QUOTA_TYPE_RANGESET = 'range_sets';
exports.HAVE_CHILDREN_QUALIFICATION_NAME = 'children';
